import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { User, ApiResponse } from '@/types/table';

interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

interface LoginPayload {
  email: string;
  password: string;
}

interface RegisterPayload {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export const authService = {
  login: async (data: LoginPayload): Promise<ApiResponse<AuthTokens & { user: User }>> => {
    const response = await api.post(API_ROUTES.AUTH.LOGIN, data);
    return response.data;
  },

  register: async (data: RegisterPayload): Promise<ApiResponse<AuthTokens & { user: User }>> => {
    const response = await api.post(API_ROUTES.AUTH.REGISTER, data);
    return response.data;
  },

  refresh: async (refreshToken: string): Promise<ApiResponse<AuthTokens>> => {
    const response = await api.post(API_ROUTES.AUTH.REFRESH, { refreshToken });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post(API_ROUTES.AUTH.LOGOUT);
  },

  forgotPassword: async (email: string): Promise<ApiResponse<{ message: string }>> => {
    const response = await api.post(API_ROUTES.AUTH.FORGOT_PASSWORD, { email });
    return response.data;
  },

  resetPassword: async (data: { token: string; password: string }): Promise<ApiResponse<{ message: string }>> => {
    const response = await api.post(API_ROUTES.AUTH.RESET_PASSWORD, data);
    return response.data;
  },

  getMe: async (): Promise<ApiResponse<User>> => {
    const response = await api.get(API_ROUTES.AUTH.ME);
    return response.data;
  },

  updateMe: async (data: Partial<User>): Promise<ApiResponse<User>> => {
    const response = await api.patch(API_ROUTES.AUTH.ME, data);
    return response.data;
  },

  changePassword: async (data: { currentPassword: string; newPassword: string }): Promise<ApiResponse<{ message: string }>> => {
    const response = await api.patch(API_ROUTES.AUTH.CHANGE_PASSWORD, data);
    return response.data;
  },
};
